export function getParameterByName(name) {
    name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
    const results = regex.exec(location.search);
    if (results === null) {
        return null;
    }
    return tryDecode(results[1].replace(/\+/g, ' '));
}
export function getParameterFromString(name, stringToExtractFrom) {
    name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
    const results = regex.exec(stringToExtractFrom);
    if (results === null) {
        return null;
    }
    return tryDecode(results[1].replace(/\+/g, ' '));
}
function tryDecode(maybeEncoded) {
    try {
        return decodeURIComponent(maybeEncoded);
    }
    catch (e) {
        console.warn(`Failed to decode param value '${maybeEncoded}'`);
        return maybeEncoded;
    }
}
